import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LinkModule } from '@shared/core/components/link';

import { CollectionTypeToggleForInlineComponent } from './collection-type-toggle-for-inline.shared.component';

@NgModule({
    declarations: [
        CollectionTypeToggleForInlineComponent
    ],
    imports: [
        CommonModule,
        LinkModule,
    ],
    exports: [
        CollectionTypeToggleForInlineComponent
    ]
})
export class CollectionTypeToggleForInlineModule { }
